export const blockIconsHardwareSmartToyNew = (
	<span className='material-symbols-outlined'>smart_toy</span>
);
